<template>
  <div class="card">
    <div class="card-header"><i class="icon-refresh"></i> Filtrer</div>

    <div class="card-block">
      <div class="row">
        <div class="form-group col-sm-4">
          <label>Perdu depuis</label>

          <multiselect
            v-model="form.lostSince"
            :options="lostSinceOptions"
            label="label"
            track-by="label"
            class="custom-multiselect"
          >
          </multiselect>
        </div>

        <div class="form-group col-sm-4">
          <label>Commercial(s)</label>

          <multiselect
            v-model="form.commercials"
            :options="commercials"
            :multiple="true"
            label="label"
            track-by="label"
            class="custom-multiselect"
          >
          </multiselect>
        </div>

        <div class="form-group col-sm-4">
          <label>Concept(s)</label>

          <multiselect
            v-model="form.concepts"
            :options="concepts"
            :multiple="true"
            :clear-on-select="false"
            :preserve-search="true"
            label="name"
            track-by="name"
            placeholder="Choisir"
            class="custom-multiselect"
          >
          </multiselect>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-sm-4">
          <label>Rechercher un {{ type }}</label>

          <input
            class="form-control"
            v-model="form.name"
            placeholder="Nom, Prénom, Email"
          />
        </div>

        <div class="form-group col-sm-4 d-flex flex-column">
          <label class="mb-1">B2B uniquement</label>

          <el-switch
            v-model="form.isB2B"
            active-text="Oui"
            inactive-text="Non"
          />
        </div>
      </div>
    </div>

    <div class="card-footer">
      <button
        type="button"
        class="btn btn-sm btn-secondary"
        @click="applyFilters()"
      >
        <i class="icon-eye"></i>&nbsp; Visualiser
      </button>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

export default {
  components: {
    Multiselect,
  },

  props: {
    type: {
      type: String,
      required: true,
    },
    commercials: {
      type: Array,
      default: () => [],
    },
    initialFilter: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      form: {
        concepts: [],
        commercials: [],
        lostSince: [],
        isB2B: false,
        name: undefined,
      },
    };
  },

  computed: {
    ...mapState({
      concepts: (state) => state.concepts,
      lostSinceOptions: (state) => state.lostSinceOptions,
    }),
  },

  watch: {
    initialFilter: {
      handler(newVal) {
        this.form = { ...this.form, ...newVal };
      },
      deep: true,
    },
  },

  mounted() {
    this.form = { ...this.form, ...this.initialFilter };
  },

  methods: {
    applyFilters() {
      this.$emit("applyFilters", this.form);
    },
  },
};
</script>
